/**
 * Theme Requirements Aggregation for Weidner Apartment Homes Oasis
 * 
 * Extends the base oasis theme requirements with Weidner Apartment Homes Oasis specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-oasis/requirements';

/**
 * Weidner Apartment Homes Oasis component requirement overrides.
 * Add requirements for any override components here.
 */
const weidnerapartmenthomesoasisOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Weidner Apartment Homes Oasis theme.
 * Inherits from oasis theme and overrides with Weidner Apartment Homes Oasis components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...weidnerapartmenthomesoasisOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
